<app-image-section-head [title]="title" [description]="description" [image]="image"></app-image-section-head>

<main id="main-content" class="container">
    <div *ngIf="applicant">
        <h2 class="my-4" i18n>Tipo de solicitante</h2>

        <div class="card">
            <div class="row">
                <div class="col-12 mb-3">
                    <label for="tipo-solicitante" class="form-label">
                        <span i18n>Tipo de solicitante</span>:
                    </label>
                    <select id="tipo-solicitante" class="form-select" [(ngModel)]="applicant.applicantType" disabled>
                        <option value="Individual" i18n>Individual</option>
                        <option value="Represented" i18n>Representado</option>
                        <option value="Company" i18n>Compañia</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="mb-3">
            <ng-container *ngIf="applicant.applicantType == 'Individual' && applicant.individual">
                <h2 class="my-4" i18n>Datos del interesado</h2>
        
                <div class="card">
                    <div class="row">
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="nombre" class="form-label"><span i18n>Nombre</span>:<span class="req" title="obligatorio">*</span></label>
                            <input type="text" class="form-control" id="nombre" [(ngModel)]="applicant.individual.applicantIdentification.name" disabled>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="primer-apellido" class="form-label"><span i18n>Primer apellido</span>:<span class="req" title="obligatorio">*</span></label>
                            <input type="text" class="form-control" id="primer-apellido" [(ngModel)]="applicant.individual.applicantIdentification.firstSurname" disabled>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="segundo-apellido" class="form-label"><span i18n>Segundo apellido</span>:</label>
                            <input type="text" class="form-control" id="segundo-apellido" [(ngModel)]="applicant.individual.applicantIdentification.secondSurname" disabled>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="fecha-nacimiento" class="form-label"><span i18n>Fecha de nacimiento</span>:<span class="req" title="obligatorio">*</span></label>
                            <input type="date" class="form-control" id="fecha-nacimiento" [(ngModel)]="applicant.individual.applicantIdentification.dateOfBirth.date" disabled>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="tipo-documento" class="form-label"><span i18n>Tipo de documento</span>:<span class="req" title="obligatorio">*</span></label>
                            <select id="tipo-documento" class="form-select" [(ngModel)]="applicant.individual.applicantIdentification.documentType" disabled>
                                <option value="">Seleccione una opción</option>
                                <option value="NIF">NIF</option>
                                <option value="NIE">NIE</option>
                                <option value="Passport">Pasaporte</option>
                                <option value="National ID">ID nacional</option>
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="firstname" class="form-label"><span i18n>Numéro de documento</span>: <span class="req" title="obligatorio">*</span></label>
                            <input type="text" class="form-control" id="firstname" [(ngModel)]="applicant.individual.applicantIdentification.documentIdentification" disabled>
                        </div>
                    </div>
                </div>
        
                <h2 class="my-4" i18n>Datos de contacto del interesado</h2>
        
                <div class="card">
                    <div class="row">
                        <div class="col-sm-6 mb-3">
                            <label for="email" class="form-label"><span i18n>Email</span>:<span class="req" title="obligatorio">*</span></label>
                            <input type="email" class="form-control" id="email" [(ngModel)]="applicant.individual.applicantContact.email">
                        </div>

                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="telefono" class="form-label"><span i18n>Teléfono de contacto</span>:<span class="req" title="obligatorio" *ngIf="applicant!.flags!.sms">*</span></label>
                            <input type="text" class="form-control" id="telefono" [(ngModel)]="applicant.individual.applicantContact.phoneNumber">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="pais-residencia" class="form-label">
                                <span i18n>País de residencia</span>:
                            </label>
                            <select id="pais-residencia" class="form-select" [(ngModel)]="applicant.individual.applicantContact.countryCode">
                                <option value="0" i18n>Selecciona un país</option>
                                @for (country of countries; track country.code) {
                                <option value="{{country.code}}">{{country.name}}</option>
                                }
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="provincia" class="form-label"><span i18n>Provincia</span>:</label>
                            <select id="provincia" class="form-select" [(ngModel)]="applicant.individual.applicantContact.province" (ngModelChange)="loadMunicipalities()">
                                <option value="" i18n>Selecciona una provincia</option>
                                @for (province of provinces; track province.code) {
                                <option value="{{province.name}}">{{province.name}}</option>
                                }
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="municipio" class="form-label"><span i18n>Municipio</span>:</label>
                            <select id="municipio" class="form-select" [(ngModel)]="applicant.individual.applicantContact.municipality" [disabled]="applicant.individual.applicantContact.province == ''">
                                <option value="" i18n>Selecciona un municipio</option>
                                @for (municipality of municipalities; track municipality.code) {
                                <option value="{{municipality.name}}">{{municipality.name}}</option>
                                }
                            </select>
                        </div>

                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="cp" class="form-label"><span i18n>Código postal</span>:</label>
                            <input type="text" class="form-control" id="cp" [(ngModel)]="applicant.individual.applicantContact.postalCode">
                        </div>

                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="stret-type" class="form-label"><span i18n>Tipo de vía</span>:</label>
                            <select id="stret-type" class="form-select" [(ngModel)]="applicant.individual.applicantContact.streetTypeCode">
                                <option value="" i18n>Selecciona un tipo de vía</option>
                                @for (strTyp of streetTypes; track strTyp.code) {
                                <option value="{{strTyp.code}}">{{strTyp.name}}</option>
                                }
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-6 mb-3">
                            <label for="nombre-via" class="form-label"><span i18n>Nombre de vía</span>:</label>
                            <input type="text" class="form-control" id="nombre-via" [(ngModel)]="applicant.individual.applicantContact.streetName">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="numero" class="form-label"><span i18n>Número</span>:</label>
                            <input type="text" class="form-control" id="numero" [(ngModel)]="applicant.individual.applicantContact.streetNumber">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="piso" class="form-label"><span i18n>Piso</span>:</label>
                            <input type="text" class="form-control" id="piso" [(ngModel)]="applicant.individual.applicantContact.floor">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="puerta" class="form-label"><span i18n>Puerta</span>:</label>
                            <input type="text" class="form-control" id="puerta" [(ngModel)]="applicant.individual.applicantContact.door">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="stairCase" class="form-label"><span i18n>Escalera</span>:</label>
                            <input type="text" class="form-control" id="stairCase" [(ngModel)]="applicant.individual.applicantContact.stairCase">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="block" class="form-label"><span i18n>Bloque</span>:</label>
                            <input type="text" class="form-control" id="block" [(ngModel)]="applicant.individual.applicantContact.block">
                        </div>
        
                        
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="applicant.applicantType == 'Represented' && applicant.represented">
                <h2 class="my-4" i18n>Datos del interesado</h2>
        
                <div class="card">
                    <div class="row">
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="nombre" class="form-label"><span i18n>Nombre</span>:</label>
                            <input type="text" class="form-control" id="nombre" [(ngModel)]="applicant.represented.applicantIdentification.name" disabled>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="primer-apellido" class="form-label"><span i18n>Primer apellido</span>:</label>
                            <input type="text" class="form-control" id="primer-apellido" [(ngModel)]="applicant.represented.applicantIdentification.firstSurname" disabled>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="segundo-apellido" class="form-label"><span i18n>Segundo apellido</span>:</label>
                            <input type="text" class="form-control" id="segundo-apellido" [(ngModel)]="applicant.represented.applicantIdentification.secondSurname" disabled>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="fecha-nacimiento" class="form-label"><span i18n>Fecha de nacimiento</span>:</label>
                            <input type="date" class="form-control" id="fecha-nacimiento" [(ngModel)]="applicant.represented.applicantIdentification.dateOfBirth.date" disabled>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="tipo-documento" class="form-label"><span i18n>Tipo de documento</span>:</label>
                            <select id="tipo-documento" class="form-select" [(ngModel)]="applicant.represented.applicantIdentification.documentType" disabled>
                                <option value="">Seleccione una opción</option>
                                <option value="NIF">NIF</option>
                                <option value="NIE">NIE</option>
                                <option value="Passport">Pasaporte</option>
                                <option value="National ID">ID nacional</option>
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="firstname" class="form-label"><span i18n>Numéro de documento</span>:</label>
                            <input type="text" class="form-control" id="firstname" [(ngModel)]="applicant.represented.applicantIdentification.documentIdentification" disabled>
                        </div>
        
                        
                    </div>
                </div>
        
                <h2 class="my-4" i18n>Datos de contacto del interesado</h2>
        
                <div class="card">
                    <div class="row">
                        <div class="col-sm-6 mb-3">
                            <label for="email" class="form-label"><span i18n>Email</span>:</label>
                            <input type="email" class="form-control" id="email" [(ngModel)]="applicant.represented.applicantContact.email">
                        </div>

                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="telefono" class="form-label"><span i18n>Teléfono de contacto</span>: </label>
                            <input type="text" class="form-control" id="telefono" [(ngModel)]="applicant.represented.applicantContact.phoneNumber">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="pais-residencia" class="form-label">
                                <span i18n>País de residencia</span>:
                            </label>
                            <select id="pais-residencia" class="form-select" [(ngModel)]="applicant.represented.applicantContact.countryCode">
                                <option value="0" i18n>Selecciona un país</option>
                                @for (country of countries; track country.code) {
                                <option value="{{country.code}}">{{country.name}}</option>
                                }
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="provincia" class="form-label"><span i18n>Provincia</span>:</label>
                            <select id="provincia" class="form-select" [(ngModel)]="applicant.represented.applicantContact.province" (ngModelChange)="loadMunicipalities()">
                                <option value="" i18n>Selecciona una provincia</option>
                                @for (province of provinces; track province.code) {
                                <option value="{{province.name}}">{{province.name}}</option>
                                }
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="municipio" class="form-label"><span i18n>Municipio</span>:</label>
                            <select id="provincia" class="form-select" [(ngModel)]="applicant.represented.applicantContact.municipality" [disabled]="applicant.represented.applicantContact.province == ''">
                                <option value="" i18n>Selecciona un municipio</option>
                                @for (municipality of municipalities; track municipality.code) {
                                <option value="{{municipality.name}}">{{municipality.name}}</option>
                                }
                            </select>
                        </div>

                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="cp" class="form-label"><span i18n>Código postal</span>:</label>
                            <input type="text" class="form-control" id="cp" [(ngModel)]="applicant.represented.applicantContact.postalCode">
                        </div>

                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="stret-type" class="form-label"><span i18n>Tipo de vía</span>:</label>
                            <select id="stret-type" class="form-select" [(ngModel)]="applicant.represented.applicantContact.streetTypeCode">
                                <option value="" i18n>Selecciona un tipo de vía</option>
                                @for (strTyp of streetTypes; track strTyp.code) {
                                <option value="{{strTyp.code}}">{{strTyp.name}}</option>
                                }
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-6 mb-3">
                            <label for="nombre-via" class="form-label"><span i18n>Nombre de vía</span>:</label>
                            <input type="text" class="form-control" id="nombre-via" [(ngModel)]="applicant.represented.applicantContact.streetName">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="numero" class="form-label"><span i18n>Número</span>:</label>
                            <input type="text" class="form-control" id="numero" [(ngModel)]="applicant.represented.applicantContact.streetNumber">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="piso" class="form-label"><span i18n>Piso</span>:</label>
                            <input type="text" class="form-control" id="piso" [(ngModel)]="applicant.represented.applicantContact.floor">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="puerta" class="form-label"><span i18n>Puerta</span>:</label>
                            <input type="text" class="form-control" id="puerta" [(ngModel)]="applicant.represented.applicantContact.door">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="stairCase" class="form-label"><span i18n>Escalera</span>:</label>
                            <input type="text" class="form-control" id="stairCase" [(ngModel)]="applicant.represented.applicantContact.stairCase">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="block" class="form-label"><span i18n>Bloque</span>:</label>
                            <input type="text" class="form-control" id="block" [(ngModel)]="applicant.represented.applicantContact.block">
                        </div>
        
                        
                    </div>
                </div>

                <h2 class="my-4" i18n>Datos del representado</h2>
        
                <div class="card">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <label for="tipo-solicitante" class="form-label"><span i18n>Relación con el representado</span>:</label>
                            <select id="tipo-solicitante" class="form-select" [(ngModel)]="applicant.represented.relationship" disabled>
                                <option value="" i18n>Seleccione tipo</option>
                                <option *ngFor="let r of relationships" [value]="r.name">{{r.name}}</option>
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="nombre" class="form-label"><span i18n>Nombre</span>:</label>
                            <input type="text" class="form-control" id="nombre" [(ngModel)]="applicant.represented.representativeIdentification.name" disabled>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="primer-apellido" class="form-label"><span i18n>Primer apellido</span>:</label>
                            <input type="text" class="form-control" id="primer-apellido" [(ngModel)]="applicant.represented.representativeIdentification.firstSurname" disabled>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="segundo-apellido" class="form-label"><span i18n>Segundo apellido</span>: </label>
                            <input type="text" class="form-control" id="segundo-apellido" [(ngModel)]="applicant.represented.representativeIdentification.secondSurname" disabled>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="fecha-nacimiento" class="form-label"><span i18n>Fecha de nacimiento</span>:</label>
                            <input type="date" class="form-control" id="fecha-nacimiento" [(ngModel)]="applicant.represented.representativeIdentification.dateOfBirth.date" disabled>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="tipo-documento" class="form-label"><span i18n>Tipo de documento</span>:</label>
                            <select id="tipo-documento" class="form-select" [(ngModel)]="applicant.represented.representativeIdentification.documentType" disabled>
                                <option value="">Seleccione una opción</option>
                                <option value="NIF">NIF</option>
                                <option value="NIE">NIE</option>
                                <option value="Passport">Pasaporte</option>
                                <option value="National ID">ID nacional</option>
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="firstname" class="form-label"><span i18n>Numéro de documento</span>:</label>
                            <input type="text" class="form-control" id="firstname" [(ngModel)]="applicant.represented.representativeIdentification.documentIdentification" disabled>
                        </div>    
                    </div>
                </div>
        
                <h2 class="my-4" i18n>Datos de contacto del representado</h2>
        
                <div class="card">
                    <div class="row">
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="telefono" class="form-label"><span i18n>Teléfono de contacto</span>: </label>
                            <input type="text" class="form-control" id="telefono" [(ngModel)]="applicant.represented.representativeContact.phoneNumber">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="pais-residencia" class="form-label">
                                <span i18n>País de residencia</span>:
                            </label>
                            <select id="pais-residencia" class="form-select" [(ngModel)]="applicant.represented.representativeContact.countryCode">
                                <option value="0" i18n>Selecciona un país</option>
                                @for (country of countries; track country.code) {
                                <option value="{{country.code}}">{{country.name}}</option>
                                }
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="provincia" class="form-label"><span i18n>Provincia</span>:</label>
                            <select id="provincia" class="form-select" [(ngModel)]="applicant.represented.representativeContact.province" (ngModelChange)="loadMunicipalities()">
                                <option value="" i18n>Selecciona una provincia</option>
                                @for (province of provinces; track province.code) {
                                <option value="{{province.name}}">{{province.name}}</option>
                                }
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="municipio" class="form-label"><span i18n>Municipio</span>:</label>
                            <select id="provincia" class="form-select" [(ngModel)]="applicant.represented.representativeContact.municipality" [disabled]="applicant.represented.representativeContact.province == ''">
                                <option value="" i18n>Selecciona un municipio</option>
                                @for (municipality of municipalities; track municipality.code) {
                                <option value="{{municipality.name}}">{{municipality.name}}</option>
                                }
                            </select>
                        </div>

                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="cp" class="form-label"><span i18n>Código postal</span>:</label>
                            <input type="text" class="form-control" id="cp" [(ngModel)]="applicant.represented.representativeContact.postalCode">
                        </div>

                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="stret-type" class="form-label"><span i18n>Tipo de vía</span>:</label>
                            <select id="stret-type" class="form-select" [(ngModel)]="applicant.represented.representativeContact.streetTypeCode">
                                <option value="" i18n>Selecciona un tipo de vía</option>
                                @for (strTyp of streetTypes; track strTyp.code) {
                                <option value="{{strTyp.code}}">{{strTyp.name}}</option>
                                }
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-6 mb-3">
                            <label for="nombre-via" class="form-label"><span i18n>Nombre de vía</span>:</label>
                            <input type="text" class="form-control" id="nombre-via" [(ngModel)]="applicant.represented.representativeContact.streetName">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="numero" class="form-label"><span i18n>Número</span>:</label>
                            <input type="text" class="form-control" id="numero" [(ngModel)]="applicant.represented.representativeContact.streetNumber">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="piso" class="form-label"><span i18n>Piso</span>:</label>
                            <input type="text" class="form-control" id="piso" [(ngModel)]="applicant.represented.representativeContact.floor">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="puerta" class="form-label"><span i18n>Puerta</span>:</label>
                            <input type="text" class="form-control" id="puerta" [(ngModel)]="applicant.represented.representativeContact.door">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="stairCase" class="form-label"><span i18n>Escalera</span>:</label>
                            <input type="text" class="form-control" id="stairCase" [(ngModel)]="applicant.represented.representativeContact.stairCase">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="block" class="form-label"><span i18n>Bloque</span>:</label>
                            <input type="text" class="form-control" id="block" [(ngModel)]="applicant.represented.representativeContact.block">
                        </div>
        
                        
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="applicant.applicantType == 'Company' && applicant.company">
                <h2 class="my-4" i18n>Datos del interesado</h2>
        
                <div class="card">
                    <div class="row">
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="nombre" class="form-label"><span i18n>Nombre</span>:</label>
                            <input type="text" class="form-control" id="nombre" [(ngModel)]="applicant.company.applicantIdentification.name" disabled>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="primer-apellido" class="form-label"><span i18n>Primer apellido</span>:</label>
                            <input type="text" class="form-control" id="primer-apellido" [(ngModel)]="applicant.company.applicantIdentification.firstSurname" disabled>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="segundo-apellido" class="form-label"><span i18n>Segundo apellido</span>:</label>
                            <input type="text" class="form-control" id="segundo-apellido" [(ngModel)]="applicant.company.applicantIdentification.secondSurname">
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="fecha-nacimiento" class="form-label"><span i18n>Fecha de nacimiento</span>:</label>
                            <input type="date" class="form-control" id="fecha-nacimiento" [(ngModel)]="applicant.company.applicantIdentification.dateOfBirth.date" disabled>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="tipo-documento" class="form-label"><span i18n>Tipo de documento</span>:</label>
                            <select id="tipo-documento" class="form-select" [(ngModel)]="applicant.company.applicantIdentification.documentType" disabled>
                                <option value="">Seleccione una opción</option>
                                <option value="NIF">NIF</option>
                                <option value="NIE">NIE</option>
                                <option value="Passport">Pasaporte</option>
                                <option value="National ID">ID nacional</option>
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="firstname" class="form-label"><span i18n>Numéro de documento</span>:</label>
                            <input type="text" class="form-control" id="firstname" [(ngModel)]="applicant.company.applicantIdentification.documentIdentification" disabled>
                        </div>
        
                        
                    </div>
                </div>
        
                <h2 class="my-4" i18n>Datos de contacto del interesado</h2>
        
                <div class="card">
                    <div class="row">
                        <div class="col-sm-6 mb-3">
                            <label for="email" class="form-label"><span i18n>Email</span>:</label>
                            <input type="email" class="form-control" id="email" [(ngModel)]="applicant.company.applicantContact.email">
                        </div>

                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="telefono" class="form-label"><span i18n>Teléfono de contacto</span>:</label>
                            <input type="text" class="form-control" id="telefono" [(ngModel)]="applicant.company.applicantContact.phoneNumber">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="pais-residencia" class="form-label">
                                <span i18n>País de residencia</span>:
                            </label>
                            <select id="pais-residencia" class="form-select" [(ngModel)]="applicant.company.applicantContact.countryCode">
                                <option value="0" i18n>Selecciona un país</option>
                                @for (country of countries; track country.code) {
                                <option value="{{country.code}}">{{country.name}}</option>
                                }
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="provincia" class="form-label"><span i18n>Provincia</span>:</label>
                            <select id="provincia" class="form-select" [(ngModel)]="applicant.company.applicantContact.province" (ngModelChange)="loadMunicipalities()">
                                <option value="" i18n>Selecciona una provincia</option>
                                @for (province of provinces; track province.code) {
                                <option value="{{province.name}}">{{province.name}}</option>
                                }
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="municipio" class="form-label"><span i18n>Municipio</span>:</label>
                            <select id="provincia" class="form-select" [(ngModel)]="applicant.company.applicantContact.municipality" [disabled]="applicant.company.applicantContact.province == ''">
                                <option value="" i18n>Selecciona un municipio</option>
                                @for (municipality of municipalities; track municipality.code) {
                                <option value="{{municipality.name}}">{{municipality.name}}</option>
                                }
                            </select>
                        </div>

                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="cp" class="form-label"><span i18n>Código postal</span>:</label>
                            <input type="text" class="form-control" id="cp" [(ngModel)]="applicant.company.applicantContact.postalCode">
                        </div>

                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="stret-type" class="form-label"><span i18n>Tipo de vía</span>:</label>
                            <select id="stret-type" class="form-select" [(ngModel)]="applicant.company.applicantContact.streetTypeCode">
                                <option value="" i18n>Selecciona un tipo de vía</option>
                                @for (strTyp of streetTypes; track strTyp.code) {
                                <option value="{{strTyp.code}}">{{strTyp.name}}</option>
                                }
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-6 mb-3">
                            <label for="nombre-via" class="form-label"><span i18n>Nombre de vía</span>:</label>
                            <input type="text" class="form-control" id="nombre-via" [(ngModel)]="applicant.company.applicantContact.streetName">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="numero" class="form-label"><span i18n>Número</span>:</label>
                            <input type="text" class="form-control" id="numero" [(ngModel)]="applicant.company.applicantContact.streetNumber">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="piso" class="form-label"><span i18n>Piso</span>:</label>
                            <input type="text" class="form-control" id="piso" [(ngModel)]="applicant.company.applicantContact.floor">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="puerta" class="form-label"><span i18n>Puerta</span>:</label>
                            <input type="text" class="form-control" id="puerta" [(ngModel)]="applicant.company.applicantContact.door">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="stairCase" class="form-label"><span i18n>Escalera</span>:</label>
                            <input type="text" class="form-control" id="stairCase" [(ngModel)]="applicant.company.applicantContact.stairCase">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="block" class="form-label"><span i18n>Bloque</span>:</label>
                            <input type="text" class="form-control" id="block" [(ngModel)]="applicant.company.applicantContact.block">
                        </div>
                    </div>
                </div>

                <h2 class="my-4" i18n>Datos de la empresa</h2>
        
                <div class="card">
                    <div class="row">
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="nombre" class="form-label"><span i18n>Nombre</span>:</label>
                            <input type="text" class="form-control" id="nombre" [(ngModel)]="applicant.company.identification.registeredName" disabled>
                        </div>
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="tipo-documento" class="form-label"><span i18n>Tipo de documento</span>:</label>
                            <select id="tipo-documento" class="form-select" [(ngModel)]="applicant.company.identification.documentType" disabled>
                                <option value="">Seleccione una opción</option>
                                <option value="NIF">NIF</option>
                                <option value="NIE">NIE</option>
                                <option value="Passport">Pasaporte</option>
                                <option value="National ID">ID nacional</option>
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="firstname" class="form-label"><span i18n>Numéro de documento</span>:</label>
                            <input type="text" class="form-control" id="firstname" [(ngModel)]="applicant.company.applicantIdentification.documentIdentification" disabled>
                        </div>
                    </div>
                </div>

                <h2 class="my-4" i18n>Datos del representado</h2>
        
                <div class="card">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <label for="tipo-solicitante" class="form-label"><span i18n>Relación con el representado</span>:</label>
                            <select id="tipo-solicitante" class="form-select" [(ngModel)]="applicant.company.relationship" disabled>
                                <option value="" i18n>Seleccione tipo</option>
                                <option *ngFor="let r of relationships" [value]="r.name">{{r.name}}</option>
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="nombre" class="form-label"><span i18n>Nombre</span>:</label>
                            <input type="text" class="form-control" id="nombre" [(ngModel)]="applicant.company.representativeIdentification.name" disabled>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="primer-apellido" class="form-label"><span i18n>Primer apellido</span>:</label>
                            <input type="text" class="form-control" id="primer-apellido" [(ngModel)]="applicant.company.representativeIdentification.firstSurname" disabled>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="segundo-apellido" class="form-label"><span i18n>Segundo apellido</span>:</label>
                            <input type="text" class="form-control" id="segundo-apellido" [(ngModel)]="applicant.company.representativeIdentification.secondSurname">
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="fecha-nacimiento" class="form-label"><span i18n>Fecha de nacimiento</span>:</label>
                            <input type="date" class="form-control" id="fecha-nacimiento" [(ngModel)]="applicant.company.representativeIdentification.dateOfBirth.date" disabled>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="tipo-documento" class="form-label"><span i18n>Tipo de documento</span>:</label>
                            <select id="tipo-documento" class="form-select" [(ngModel)]="applicant.company.representativeIdentification.documentType" disabled>
                                <option value="">Seleccione una opción</option>
                                <option value="NIF">NIF</option>
                                <option value="NIE">NIE</option>
                                <option value="Passport">Pasaporte</option>
                                <option value="National ID">ID nacional</option>
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="firstname" class="form-label"><span i18n>Numéro de documento</span>:</label>
                            <input type="text" class="form-control" id="firstname" [(ngModel)]="applicant.company.representativeIdentification.documentIdentification" disabled>
                        </div>    
                    </div>
                </div>
        
                <h2 class="my-4" i18n>Datos de contacto del representado</h2>
        
                <div class="card">
                    <div class="row">
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="telefono" class="form-label"><span i18n>Teléfono de contacto</span>: </label>
                            <input type="text" class="form-control" id="telefono" [(ngModel)]="applicant.company.representativeContact.phoneNumber">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="pais-residencia" class="form-label">
                                <span i18n>País de residencia</span>:
                            </label>
                            <select id="pais-residencia" class="form-select" [(ngModel)]="applicant.company.representativeContact.countryCode">
                                <option value="0" i18n>Selecciona un país</option>
                                @for (country of countries; track country.code) {
                                <option value="{{country.code}}">{{country.name}}</option>
                                }
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="provincia" class="form-label"><span i18n>Provincia</span>:</label>
                            <select id="provincia" class="form-select" [(ngModel)]="applicant.company.representativeContact.province" (ngModelChange)="loadMunicipalities()">
                                <option value="" i18n>Selecciona una provincia</option>
                                @for (province of provinces; track province.code) {
                                <option value="{{province.name}}">{{province.name}}</option>
                                }
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="municipio" class="form-label"><span i18n>Municipio</span>:</label>
                            <select id="provincia" class="form-select" [(ngModel)]="applicant.company.representativeContact.municipality" [disabled]="applicant.company.representativeContact.province == ''">
                                <option value="" i18n>Selecciona un municipio</option>
                                @for (municipality of municipalities; track municipality.code) {
                                <option value="{{municipality.name}}">{{municipality.name}}</option>
                                }
                            </select>
                        </div>

                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="cp" class="form-label"><span i18n>Código postal</span>:</label>
                            <input type="text" class="form-control" id="cp" [(ngModel)]="applicant.company.representativeContact.postalCode">
                        </div>

                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="stret-type" class="form-label"><span i18n>Tipo de vía</span>:</label>
                            <select id="stret-type" class="form-select" [(ngModel)]="applicant.company.representativeContact.streetTypeCode">
                                <option value="" i18n>Selecciona un tipo de vía</option>
                                @for (strTyp of streetTypes; track strTyp.code) {
                                <option value="{{strTyp.code}}">{{strTyp.name}}</option>
                                }
                            </select>
                        </div>
        
                        <div class="col-sm-6 col-xl-6 mb-3">
                            <label for="nombre-via" class="form-label"><span i18n>Nombre de vía</span>:</label>
                            <input type="text" class="form-control" id="nombre-via" [(ngModel)]="applicant.company.representativeContact.streetName">
                        </div>
        
                        <div class="col-sm-6 col-xl-4 mb-3">
                            <label for="numero" class="form-label"><span i18n>Número</span>:</label>
                            <input type="text" class="form-control" id="numero" [(ngModel)]="applicant.company.representativeContact.streetNumber">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="piso" class="form-label"><span i18n>Piso</span>:</label>
                            <input type="text" class="form-control" id="piso" [(ngModel)]="applicant.company.representativeContact.floor">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="puerta" class="form-label"><span i18n>Puerta</span>:</label>
                            <input type="text" class="form-control" id="puerta" [(ngModel)]="applicant.company.representativeContact.door">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="stairCase" class="form-label"><span i18n>Escalera</span>:</label>
                            <input type="text" class="form-control" id="stairCase" [(ngModel)]="applicant.company.representativeContact.stairCase">
                        </div>
        
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label for="block" class="form-label"><span i18n>Bloque</span>:</label>
                            <input type="text" class="form-control" id="block" [(ngModel)]="applicant.company.representativeContact.block">
                        </div>
                    </div>
                </div>
            </ng-container>

            <h2 class="my-4" i18n>Datos de autenticación</h2>

            <div class="card">
                <div class="row">
                    <div class="col-12 mb-3">
                        <p i18n>Si desea cambiar su contraseña, por favor, escriba la nueva contraseña.</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-6">
                        <label for="username" class="form-label"><span i18n>Usuario</span>:</label>
                        <input type="text" class="form-control" id="username" *ngIf="applicant.individual" [(ngModel)]="applicant.individual.applicantIdentification.documentIdentification" disabled>
                        <input type="text" class="form-control" id="username" *ngIf="applicant.represented" [(ngModel)]="applicant.represented.applicantIdentification.documentIdentification" disabled>
                        <input type="text" class="form-control" id="username" *ngIf="applicant.company" [(ngModel)]="applicant.company.applicantIdentification.documentIdentification" disabled>
                    </div>
    
                    <div class="col-sm-12 col-md-6">
                        <label for="password" class="form-label"><span i18n>Cambiar contraseña</span>:</label>
                        <input type="password" class="form-control" id="password" autocomplete="new-password" [(ngModel)]="password">
                    </div>

                    <small class="col-12 mb-3 small-text" i18n>* La contraseña debe tener entre 8 y 30 caracteres, e incluir números, símbolos, mayúsculas y minúsculas.</small>
                </div>
            </div>
        </div>

        <h2 class="my-4" i18n>¿Por qué medio quiere ser comunicado?</h2>
        <div class="card mb-3">
            <div class="row">
                <div class="col-sm-12 col-md-6 mb-3">
                    <div class="row pt-2">
                        <div class="col-12">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch" id="email-check"
                                    [(ngModel)]="applicant!.flags!.email" (change)="changeFlag('email')">
                                <label class="form-check-label" for="email-check" i18n>Recibir notificaciones por
                                    email</label>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch" id="sms"
                                    [(ngModel)]="applicant!.flags!.sms" (change)="changeFlag('sms')">
                                <label class="form-check-label" for="sms" i18n>Recibir notificaciones por sms</label>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="col-sm-12 col-md-6 mb-3">
                    <label for="language" i18n>Idioma notificación: </label>
                    <select class="form-select" id="language" [(ngModel)]="applicant!.flags!.language"
                        (change)="changeFlag('language')">
                        <option value="" i18n>Selecciona Idioma</option>
                        <option value="ca-ES" i18n>Catalan</option>
                        <option value="es-ES" i18n>Español</option>
                        <option value="en-GB" i18n>Ingles</option>
                    </select>
                </div>
    
            </div>
            <p i18n>Si desea ser contactado por otro medio, puede solicitarlo a través del formulario en el apartado <a routerLink="/contact" target="_blank">Contacto</a>.</p>
        </div>
        
        <div class="row">
            <div class="col-12 text-center">
                <button type="button" class="btn btn-primary" (click)="save(undefined)" i18n>Guardar</button>
            </div>
        </div>

    </div>

</main>